export default __webpack_public_path__ + "static/media/icon-taks-chat.8f63271e.svg";